exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".benutzerverwaltung-view.container{width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/benutzerverwaltung/component/benutzerListView/benutzerListView.scss
// module id = 9+RF
// module chunks = 0